import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,{attrs:{"cols":"12"}},[_c(VLayout,{attrs:{"row":"","wrap":""}},_vm._l((_vm.levels),function(item,index){return _c(VFlex,{key:index,attrs:{"xs12":"","sm6":"","md3":""}},[_c(VCheckbox,{attrs:{"color":_vm.getTagColor(item),"label":item,"value":item,"dark":_vm.darkMode,"hide-details":""},model:{value:(_vm.listLocal),callback:function ($$v) {_vm.listLocal=$$v},expression:"listLocal"}})],1)}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }